import { Typography, Icon, ICONS_ENUM, Tooltip } from '@sanlam-glacier/app-common/components';
import { WidgetType } from 'modules/dashboard/types';
import styles from '../../widget/widget.module.scss';
import { PropsWithChildren } from 'react';

interface WidgetTitleProps {
  type: WidgetType;
  heading: string;
  helpHeadingText?: string;
  helpSubText?: string;
}

export const WidgetTitle = ({
  type,
  heading,
  helpHeadingText,
  helpSubText
}: PropsWithChildren<WidgetTitleProps>) => {
  return (
    <Typography
      data-testid={`${type}HeadingLabel`}
      variant={Typography.VARIANT.B2}
      weight={Typography.WEIGHT.MEDIUM}
    >
      {heading}
      {helpHeadingText && (
        <Tooltip
          data-testid={`${type}DescriptionTooltip`}
          position={Tooltip.POSITION.TOP}
          headline={helpHeadingText}
          content={
            <>
              <br />
              {helpSubText}
            </>
          }
        >
          <span className={styles.helpIconContainer} data-testid={`${type}TooltipContainer`}>
            <Icon
              data-testid={`${type}DescriptionIcon`}
              icon={ICONS_ENUM.ACTION_HELP}
              className={styles.helpIcon}
            />
          </span>
        </Tooltip>
      )}
    </Typography>
  );
};
